export default "__VITE_ASSET__B_kRx3yg__"